var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 459.17 433.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #5c92cd;\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        isolation: isolate;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-20 {\n        letter-spacing: 0em;\n      }\n\n      .cls-21, .cls-22 {\n        fill: #fff;\n      }\n\n      .cls-23 {\n        fill: #c1d6a0;\n      }\n\n      .cls-24 {\n        fill: #bed69f;\n      }\n\n      .cls-25 {\n        fill: #e0aca0;\n      }\n\n      .cls-26 {\n        fill: #282828;\n      }\n\n      .cls-22 {\n        font-size: 14.68px;\n      }\n\n      .cls-22, .cls-12 {\n        font-family: Roobert-SemiBold, Roobert;\n      }\n\n      .cls-27 {\n        letter-spacing: 0em;\n      }\n\n      .cls-28 {\n        fill: #231f20;\n        mix-blend-mode: darken;\n        opacity: .11;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-width: .5px;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6 {\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-29 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10 {\n        opacity: .75;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45 {\n        opacity: .46;\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-3 {\n        stroke: #ed1c24;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-12 {\n        font-size: 18.28px;\n      }\n\n      .cls-12, .cls-18 {\n        fill: #68a543;\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-57 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-14 {\n        fill: #3a512a;\n      }\n\n      .cls-15 {\n        fill: #232323;\n      }\n\n      .cls-16 {\n        fill: #cfe5b0;\n      }\n\n      .cls-17 {\n        fill: #ebf3d8;\n      }\n\n      .cls-58 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 242.46,
    y1: 433.42,
    x2: 242.46,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fdfefc",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fafcf5",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f4f9ea",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edf4d9",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e3eec4",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d6e7ab",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c8df8d",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1db7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 235.25,
    y1: 327.92,
    x2: 235.25,
    y2: 68.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fdfdfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f7faef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#edf4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eec6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 24,
    y1: 188.62,
    x2: 84.12,
    y2: 188.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9cc65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#a0b94e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8daa3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 36.95,
    y1: 216.57,
    x2: 87.37,
    y2: 216.57,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 225.87,
    y1: 114.3,
    x2: 286.22,
    y2: 114.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9df80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b2d367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1d366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 125.47,
    y2: 125.47,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 253.15,
    y2: 253.15,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 236.93,
    y1: 269.18,
    y2: 269.18,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 150.57,
    y1: 167.48,
    x2: 189.15,
    y2: 167.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 150.57,
    y1: 193.25,
    x2: 189.15,
    y2: 193.25,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 150.57,
    y1: 221.12,
    x2: 189.15,
    y2: 221.12,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 198.35,
    y1: 167.48,
    x2: 236.93,
    y2: 167.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 198.35,
    y1: 193.25,
    x2: 236.93,
    y2: 193.25,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 198.35,
    y1: 221.12,
    x2: 236.93,
    y2: 221.12,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 246.89,
    y1: 167.48,
    x2: 285.47,
    y2: 167.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 246.89,
    y1: 193.25,
    x2: 285.47,
    y2: 193.25,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 246.89,
    y1: 221.12,
    x2: 285.47,
    y2: 221.12,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 150.57,
    y1: 137.92,
    y2: 137.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 339.81,
    y1: 317.23,
    x2: 339.81,
    y2: 68.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fdfefc",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fafcf5",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f3f8e9",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#eaf3d9",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#dfedc4",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d1e6aa",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c1dd8c",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bad97e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 225.9,
    y1: 318.34,
    x2: 348.52,
    y2: 318.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62843a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#65873d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6f9348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#81a75a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88af62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 232.14,
    y1: 316.2,
    x2: 255.67,
    y2: 316.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8f6fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 260.93,
    x2: 284.46,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 289.73,
    x2: 313.25,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 333.09,
    y2: 333.09,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 260.93,
    y1: 333.09,
    x2: 284.46,
    y2: 333.09,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 289.73,
    y1: 333.09,
    x2: 313.25,
    y2: 333.09,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 318.52,
    x2: 342.04,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 77.31,
    y1: 68.59,
    x2: 207.85,
    y2: 68.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 352.22,
    y1: 321.36,
    x2: 396.88,
    y2: 321.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 352.16,
    y1: 323.31,
    x2: 395.09,
    y2: 323.31,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 354.2,
    y1: 269.34,
    x2: 407.55,
    y2: 288.76,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 362.46,
    y1: 281.11,
    x2: 397.79,
    y2: 281.11,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 402.32,
    y1: 294.56,
    x2: 438.82,
    y2: 294.56,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 403.81,
    y1: 294.89,
    x2: 438.82,
    y2: 294.89,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 404.38,
    y1: 335.28,
    x2: 450.27,
    y2: 335.28,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 406.02,
    y1: 337.3,
    x2: 450.27,
    y2: 337.3,
    xlinkHref: "#linear-gradient-20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 242.46,
    cy: 216.71,
    r: 216.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M441.98,405.81c0,2.75-19.01,4.99-42.47,4.99s-42.48-2.24-42.48-4.99c0-2.16,11.65-3.99,27.95-4.69l.44,4.51h32.57l.42-4.29c13.97,.82,23.57,2.51,23.57,4.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 130.7,
    y: 68.59,
    width: 209.11,
    height: 259.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.88,370.17c.1-.65,.18-1.3,.26-1.96,1.38-12.04-1.05-24.68-1.05-24.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,371.65c.09-1.05,.16-2.21,.21-3.44,.78-18.39-2.42-54.43-2.42-54.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.32,371.65c-.15-1.03-.26-2.18-.34-3.44-.94-14.06,1.83-40.54,1.83-40.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.38,370.98c-.06-.85-.06-1.79,0-2.78,.25-4.89,1.65-10.78,1.65-10.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M68.9,142.94c-.34,.21-.7,.36-1.06,.46-2.14,.61-4.5-.47-6.61-.87-1.5-.29-3.04-.4-4.57-.31-.63,.04-1.3,.12-1.86,.44-.61,.37-.86,1-.98,1.67-.49,2.79,.92,5.55,.7,8.36-.02,.31-.3,.58-.63,.48-.96-.29-1.62-1.04-2.03-1.93-.23-.49-.39-1.01-.6-1.52-.09-.23-.22-.68-.42-.85-.45-.38-.55,.2-.56,.56-.03,1.36,.09,2.74,.29,4.08,.17,1.17,.45,2.32,.11,3.48-.1,.34-.43,.41-.68,.31-.16-.07-.29-.23-.29-.43-.03-.02-.06-.03-.09-.05-2-1.89-3.08-4.5-3.54-7.17-.26-1.46-.24-2.92-.39-4.38-.08-.81-.35-1.59-.45-2.4-.1-.85,.01-1.7,.14-2.55,.37-2.42,.87-5.02,3.07-6.47,2.21-1.46,4.98-1.28,7.5-1.17,1.54,.08,3.02,.01,4.55-.22,1.4-.21,2.82-.45,4.24-.29,2.41,.27,4.56,1.81,5.51,4.06,.9,2.14,.86,5.38-1.35,6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M68.52,159.13c-.04,1.05-.09,2.16-.66,3.04-.49,.78-1.34,1.28-2.23,1.52-.89,.24-1.82,.24-2.74,.19-.05,1.5-.05,3-.01,4.49,.03,1.08,.09,2.15,.17,3.23,.04,.51,.08,1.03-.08,1.51-.41,1.2-1.89,1.63-3.16,1.64-4.02,.03-7.79-2.5-9.86-5.95-.2-.34-.4-.7-.48-1.1-.06-.27-.06-.53-.04-.8,.01-.26,.05-.52,.09-.78,.43-2.92,.59-5.87,.48-8.82,.25,.1,.58,.03,.68-.31,.34-1.16,.06-2.31-.11-3.48-.2-1.34-.32-2.72-.29-4.08,0-.36,.11-.94,.56-.56,.2,.17,.33,.62,.42,.85,.21,.51,.37,1.03,.6,1.52,.41,.89,1.07,1.64,2.03,1.93,.33,.1,.61-.17,.63-.48,.22-2.81-1.19-5.57-.7-8.36,.12-.67,.37-1.3,.98-1.67,.56-.32,1.23-.4,1.86-.44,1.53-.09,3.07,.02,4.57,.31,2.11,.4,4.47,1.48,6.61,.87,1.01,5.16,.85,10.47,.68,15.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M84.12,185.76c-.38,.08-.8,.18-1.26,.3-3.09,.8-6.9,2.7-8.4,5.47-1.51,2.77-.79,3.88-4.52,5.46-3.72,1.59-25.89,10.84-30.17,13.35,.11-.61,.32-1.21,.49-1.81,.56-2.02,.66-4.18,1.36-6.15-5.27-.71-10.57-1.29-15.87-1.64-.58-.04-1.17-.08-1.75-.11,.88-7.49,2.08-14.94,3.62-22.32,.5-2.41,1.12-4.98,2.94-6.64,1.06-.97,2.43-1.53,3.79-1.99,4.85-1.63,9.99-2.22,15.08-2.78-.02,.27-.02,.53,.04,.8,.08,.4,.28,.76,.48,1.1,2.07,3.45,5.84,5.98,9.86,5.95,1.27-.01,2.75-.44,3.16-1.64,.16-.48,.12-1,.08-1.51-.08-1.08-.14-2.15-.17-3.23,4.15-.05,8.3,1.16,11.78,3.41,3.59,2.32,6.44,5.75,8.07,9.7,.57,1.39,1,2.83,1.39,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M87.37,204.55c-.11,.03-.22,.06-.33,.08-1.7,.44-3.44,.83-5.12,.39,1.14,7.66-.48,15.47-.24,23.2,.02,.72,.06,1.45,.12,2.18,.25,3.04,.85,6.05,1,9.09,.06,1.27,.1,2.44,.32,3.69-2.53,1.51-5.6,1.76-8.54,1.9-10.52,.49-21.09,.07-31.53-1.26-2.19-.28-4.46-.84-6.1-2.31,0-4.56,.48-9.11,1.04-13.66,1.33-.63,2.81-1.4,4.47-2.34,14.73-8.32,32-23.41,33.43-24.78,1.42-1.36,4.9,.04,7.44-3.66,2.54-3.69-.71-5.62-.63-7.28,.04-.73,.95-1.37,1.97-1.92,.75,3.06,1.36,6.13,1.83,9.23h0c-.27,.43-.53,.85-.8,1.27,.33,.03,.67,.07,1,.1,.28,2.01,.5,4.04,.67,6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.67,198.7c-.11,.2-.23,.41-.35,.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M112.17,189.88c-.81,1.53-2.04,2.78-3.19,4.08-8.75,9.88-13.33,23.13-23.07,32.04-1.2,1.1-2.64,2.17-4.23,2.22-.24-7.73,1.38-15.54,.24-23.2,1.68,.44,3.42,.05,5.12-.39,.09,1.07,.17,2.14,.26,3.21,2.02-3.08,5.08-5.42,7.02-8.54,3.08,.37,6.15,.76,9.22,1.18l4.04-7.08c-2.13-.82-3.97-2.37-5.12-4.34-.33-.57-.62-1.21-.57-1.86,.1-1.37,1.52-2.22,2.84-2.61,1.66-.48,3.42-.6,5.13-.34,.69,.1,1.39,.27,1.94,.7,.24,.19,.44,.41,.58,.66,.75,1.19,.49,2.96-.21,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M121.42,170.5c-3.37,4.72-6.39,9.94-9.04,15.11-.14-.25-.34-.47-.58-.66-.55-.43-1.25-.6-1.94-.7-1.71-.26-3.47-.14-5.13,.34-1.32,.39-2.74,1.24-2.84,2.61-.05,.65,.24,1.29,.57,1.86,1.15,1.97,2.99,3.52,5.12,4.34l-4.04,7.08c-3.07-.42-6.14-.81-9.22-1.18-2.54-.29-5.08-.57-7.62-.83-.33-.03-.67-.07-1-.1,.27-.42,.53-.84,.8-1.26h0c5.93-9.38,11.8-18.6,17.73-27.98,5.75,.67,11.59-.07,17.19,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.38,185.61s-.03,.07-.05,.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.75,200.74h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M87.37,186.06c0,.53-1.43,1.11-2.7,1.81-1.02,.55-1.93,1.19-1.97,1.92-.08,1.66,3.17,3.59,.63,7.28-2.54,3.7-6.02,2.3-7.44,3.66-1.43,1.37-18.7,16.46-33.43,24.78-1.66,.94-3.14,1.71-4.47,2.34-10.48,4.9-11.33,.42-12.24-7.73-1-9.01-.04-19.01,0-19.38,5.3,.35,10.6,.93,15.87,1.64-.7,1.97-.8,4.13-1.36,6.15-.17,.6-.38,1.2-.49,1.81,4.28-2.51,26.45-11.76,30.17-13.35,3.73-1.58,3.01-2.69,4.52-5.46,1.5-2.77,5.31-4.67,8.4-5.47,.46-.12,.88-.22,1.26-.3,2.21-.51,3.25-.51,3.25,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M47.05,385.81v5.26h-11.37v-5.71c2,.7,5.69,1.44,11.37,.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 47.05,
    y1: 385.81,
    x2: 47.05,
    y2: 385.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M210.2,256.33v-1.31c0-4.04-3.5-6.22-6.79-6.22-1.72,0-3.31,.57-4.49,1.61-.95,.84-2.08,2.39-2.08,5,0,1.05,.32,2.33,.74,3.69h-3.69v2.62h4.52c.83,2.63,1.59,5.55,.56,6.96-.58,.8-1.85,1.21-3.78,1.21-.72,0-1.31,.59-1.31,1.31s.59,1.31,1.31,1.31h15v-2.62h-8.89c1.33-2.2,.72-5.23-.16-8.17h4.95v-2.62h-5.78c-.47-1.47-.86-2.81-.86-3.69,0-1.31,.4-2.33,1.19-3.04,.7-.62,1.67-.96,2.75-.96,2.07,0,4.17,1.24,4.17,3.6v1.31h2.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 225.87,
    y: 111.45,
    width: 60.36,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 225.87,
    y: 122.61,
    width: 60.36,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 225.87,
    y: 249.06,
    width: 60.36,
    height: 8.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 236.93,
    y: 265.09,
    width: 49.29,
    height: 8.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 150.57,
    y: 162.47,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 150.57,
    y: 188.24,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 150.57,
    y: 216.11,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 198.35,
    y: 162.47,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 198.35,
    y: 188.24,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 198.35,
    y: 216.11,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 246.89,
    y: 162.47,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 246.89,
    y: 188.24,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 246.89,
    y: 216.11,
    width: 38.58,
    height: 10.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 150.57,
    y: 135.85,
    width: 135.65,
    height: 4.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 149.82,
    y: 149.91,
    width: 135.65,
    height: 2.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 149.82,
    y: 236.56,
    width: 135.65,
    height: 2.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(149.82 127)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 17.89,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 29.19,
    y: 0
  }, "OI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 48.31,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.58,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 309.31,
    y: 68.59,
    width: 61,
    height: 248.64,
    rx: 30.42,
    ry: 30.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 379.33,
    y: 368.32,
    width: 44.75,
    height: 6.81,
    rx: 2.45,
    ry: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M402.89,375.13s-6.89,0-8.67,6.5c-1.19,4.33-.79,13.57-.39,19.24,.19,2.82,.39,4.76,.39,4.76h-8.8l-.44-4.51-2.56-25.99h20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M420.99,375.13l-2.58,26.21-.42,4.29h-23.77s-.2-1.94-.39-4.76c-.4-5.67-.8-14.91,.39-19.24,1.78-6.5,8.67-6.5,8.67-6.5h18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.97,406.22c-4.87,.66-12.65-.71-12.65-.71,.43-.7,1.06-3.19,1.66-5.92,.89-4.01,1.7-8.52,1.7-8.52h11.37s.54-.23,1.13,5.83c.07,.74,.15,1.44,.23,2.08,.54,4.59,.84,6.67-3.44,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M130.7,405.8c0,3.87-29.26,7.01-65.35,7.01S0,409.67,0,405.8c0-2.66,13.73-4.96,33.98-6.16-.6,2.73-1.23,5.22-1.66,5.92,0,0,7.78,1.37,12.65,.71,4.28-.57,3.98-2.65,3.44-7.24,5.4-.16,11.08-.24,16.94-.24,.94,0,1.87,0,2.79,.01-.12,1.29-.28,2.46-.47,3.31l-.83,3.69s18,1.66,26.02,1.01c8.02-.66,8.73-.06,4.69-2.91-1.78-1.26-4.4-2.68-7.2-4.58,23.69,1.05,40.35,3.55,40.35,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M79.9,389.45l-11.28-.69s-.17-3.27-.44-4.74c.14,.03,.28,.07,.44,.1h0c2.46,.56,7.18,1.42,10.99,.86l.29,4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.75,384.48c-.66,.23-1.38,.4-2.14,.5-3.81,.56-8.53-.3-10.99-.85h0c-.16-.04-.3-.08-.44-.11-.77-.18-1.23-.31-1.23-.31,0,0-3.26-39.39-3.5-61.96-.24-22.58-3.09-45.86-3.09-45.86-1.43,26.85-12.59,109.78-12.59,109.78-.24,.05-.48,.09-.72,.14-5.68,.99-9.37,.25-11.37-.45-1.25-.45-1.83-.88-1.83-.88,0,0,2.04-57.51,.37-93.62-1.66-36.12,2.73-49.35,2.73-49.35,1.64,1.47,3.91,2.03,6.1,2.31,10.44,1.33,21.01,1.75,31.53,1.26,2.94-.14,6.01-.39,8.54-1.9,1.92,14.98,1.32,22.65,1.95,58.95,.64,36.31-3.32,82.35-3.32,82.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M92.86,406.76c-8.02,.65-26.02-1.01-26.02-1.01l.83-3.69c.19-.85,.35-2.02,.47-3.31,.41-4.3,.48-9.99,.48-9.99l11.28,.69c2.76,4.62,6.89,7.41,10.45,9.82,2.8,1.9,5.42,3.32,7.2,4.58,4.04,2.85,3.33,2.25-4.69,2.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 225.9,
    y: 283.25,
    width: 122.61,
    height: 70.18,
    rx: 5.02,
    ry: 5.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 225.9,
    y: 292.99,
    width: 122.61,
    height: 13.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 232.14,
    y: 313.82,
    width: 23.52,
    height: 4.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 260.93,
    y: 313.82,
    width: 23.52,
    height: 4.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 289.73,
    y: 313.82,
    width: 23.52,
    height: 4.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 232.14,
    y: 329.82,
    width: 23.52,
    height: 6.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.93,
    y: 329.82,
    width: 23.52,
    height: 6.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 289.73,
    y: 329.82,
    width: 23.52,
    height: 6.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 318.52,
    y: 313.82,
    width: 23.52,
    height: 4.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M333.95,325.2h-7.34c-1.42,0-2.72,.76-3.43,1.98l-3.67,6.35c-.71,1.23-.71,2.74,0,3.96l3.67,6.35c.71,1.23,2.02,1.98,3.43,1.98h7.34c1.42,0,2.72-.76,3.43-1.98l3.67-6.35c.71-1.23,.71-2.74,0-3.96l-3.67-6.35c-.71-1.23-2.02-1.98-3.43-1.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 77.31,
    y: 43.25,
    width: 130.53,
    height: 50.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 171.09,
    y: 56.55,
    width: 20.91,
    height: 25.43,
    rx: 2.79,
    ry: 2.79
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(90.78 68.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 14.37,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.45,
    y: 0
  }, "OI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 38.81,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.46,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 90.54,
    y: 77.54,
    width: 74.53,
    height: 1.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.89,
    y1: 64.32,
    x2: 188.2,
    y2: 64.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.89,
    y1: 68.44,
    x2: 188.2,
    y2: 68.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.89,
    y1: 72.55,
    x2: 188.2,
    y2: 72.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.89,
    y1: 76.67,
    x2: 188.2,
    y2: 76.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M395.09,344.4s-.59-24.2-14.89-36.91c-9.95-8.84-26.85-4.14-27.98-3.82,25.3-10.59,32.74-4.25,39.07,8.89,6.34,13.15,6.81,30.26,3.8,31.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M395.09,344.4s-3.32,2.38-14.89-18.06c-13.72-24.24-28.04-22.65-28.04-22.65,0,0,.02-.01,.06-.02,1.13-.32,18.03-5.02,27.98,3.82,14.3,12.71,14.89,36.91,14.89,36.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M397.79,315.57s-.32-66.54-35.33-68.91c0,0,21.23-4.28,29.31,13.15,8.07,17.42,7.65,42.84,6.02,55.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M397.79,315.57s-10.14-7.76-15.53-29.31c-5.39-21.54-8.87-32.47-19.8-39.6,35.01,2.37,35.33,68.91,35.33,68.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M438.82,260.76s-30.74-.16-35.01,68.27c0,0-5.12-25.83,3.64-50.06,8.76-24.22,31.37-18.21,31.37-18.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M438.82,260.76c-5.87,2.37-15.37,17.11-19.49,38.81-4.12,21.7-15.52,29.46-15.52,29.46,4.27-68.43,35.01-68.27,35.01-68.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M450.27,318.34c-41.78-13.07-44.25,39.53-44.25,39.53-4.75-9.83,1.43-30.9,10.93-41.03,9.51-10.14,33.32,1.5,33.32,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M450.27,318.34c-8.83-1.66-15.42,5.15-22.54,12.91-7.13,7.76-19.73,30.69-21.71,26.62,0,0,2.47-52.6,44.25-39.53Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ccc8c6ca64a33d4effda5b64219ab81a.svg";
export { ForwardRef as ReactComponent };